import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles<Theme>(theme => ({
  bar: {
    display: "flex",
    justifyContent: "space-between"
  }
}));
